module.exports = __webpack_public_path__ + "img/userImgForChatSettings.512ae52f.png";